import React from "react";
import { Header, NavBar, VideoCard } from "../../components";
import { useAuth } from "../../context";
import { useDocumentTitle } from "../../customHooks";
import styles from './profilepage.module.css'
import "../commonPage.css";

export const ProfilePage = () => {
  useDocumentTitle("Profile");
  const { channelProfile } = useAuth();
  const { channel, videosByUser } = channelProfile;
  return (
    <main className="page-main">
      <Header />
      <NavBar />
      <section className="page-content">
        <div className="profile__section">
          <div className={styles.coverimage__wrapper}>
            <img
              loading="lazy"
              className={styles.coverimage}
              src={channel?.coverImage}
              alt="coverImage"
            />
          </div>
          <div className={styles.avatar__wrapper}>
            <img loading="lazy" className={styles.avater__image} src={channel?.avatar} alt="avatar" />
          </div>
          <div className={styles.profile__details}>
            <div>
              <div className={styles.user__fullname}>{channel?.fullName}</div>
              <div className={styles.user__username}>@{channel?.username}</div>
            </div>
          </div>
        </div>
        {videosByUser?.length > 0 && <div className={styles.video__section}>
          {videosByUser.map((video) => (
            <VideoCard
              key={video._id}
              video={video}
              isExplore={true}
              avatar={channel?.avatar}
            />
          ))}
        </div>}
      </section>
    </main>
  );
};
